import React, { useState, useEffect } from 'react';
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import { useTranslation } from 'react-i18next';
import TextArea from 'devextreme-react/text-area';
import { Container } from './style';

export const NotesModal = (props) => {
    const { t } = useTranslation();
    const [noteValue, setNoteValue] = useState('');

    useEffect(() => {
        setNoteValue(props.currentValue)
    }, [props]);

    const renderTitle = () => {
        return (<h6 className="mb-3">{t(props.title)}</h6>)
    }

    const handleChangeSelection = (e) => {
        setNoteValue(e.value);
    }

    const handleSaveClick = () => {
        props.handleOnSaveClick(noteValue)
    }

    const onInit = (e) => {
        e.component.registerKeyHandler("escape", function () {
            props.handleOnCancelClick(e);
        });
    }

    return (
        <Popup
            visible={props.showModal}
            dragEnabled={false}
            onInitialized={onInit}
            hideOnOutsideClick={false}
            showCloseButton={false}
            titleRender={renderTitle}
            position={{ my: 'center', at: 'center', collision: "fit" }}
            container="#root" width='600px' height='auto'>
            <Container>
                <label className="notes-header">{t('LABELS.NOTES')}</label>
                <TextArea
                    minHeight={'200px'}
                    defaultValue={''}
                    stylingMode='outlined'
                    value={noteValue}
                    autoResizeEnabled={true}
                    valueChangeEvent={'keyup'}
                    onValueChanged={handleChangeSelection}
                />
                <div className="d-flex flex-row justify-content-end gap-standard px-1 pb-1 mt-4">
                    <Button text={t('BUTTONS.CANCEL')} type="normal" stylingMode="outlined" onClick={props.handleOnCancelClick} />
                    <Button className="mr-3" text={t('BUTTONS.SAVE')} type="default" stylingMode="contained" onClick={handleSaveClick} />
                </div>
            </Container>
        </Popup>
    );
}